export default __webpack_public_path__ + "media/color/lpt-04f48778.svg";